import React from 'react';

const STATUS_BADGE_VARIANTS = {
  success: { color: '#01AB7D', backgroundColor: '#E6F7F2' },
  warning: { color: '#ffa800', backgroundColor: 'rgba(255, 168, 0, 0.12)' },
  danger: { color: '#dc3545', backgroundColor: 'rgba(220, 53, 69, 0.12)' },
};

export const StatusBadge = ({ label, variant }) => {
  const { color, backgroundColor } =
    STATUS_BADGE_VARIANTS[variant] || STATUS_BADGE_VARIANTS.danger;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        color,
        backgroundColor,
        padding: '4px 10px',
        borderRadius: '6px',
        fontSize: '12px',
        fontWeight: 600,
        whiteSpace: 'nowrap',
      }}
    >
      <span
        style={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          backgroundColor: color,
          flexShrink: 0,
        }}
      />
      {label}
    </span>
  );
};
